export default __webpack_public_path__ + "static/media/bandaban.0141833a.jpg";